import { UseMutationOptions, useQueryClient } from "@tanstack/react-query";

import { graphql } from "lib/generated/app-service-gql";
import {
  CreatePinnedViewMutation,
  CreatePinnedViewMutationVariables,
} from "lib/generated/app-service-gql/graphql";
import { useGraphQlMutation } from "../useGraphQlClient";

const createPinnedView = graphql(`
  mutation CreatePinnedView($input: CreatePinnedSavedViewRequest!) {
    createPinnedView(CreatePinnedSavedViewRequest: $input) {
      id
    }
  }
`);

export function useCreatePinnedView(
  options?: UseMutationOptions<
    CreatePinnedViewMutation,
    unknown,
    CreatePinnedViewMutationVariables,
    unknown
  >,
) {
  const queryClient = useQueryClient();

  const { data, ...rest } = useGraphQlMutation(createPinnedView, {
    ...options,
    onSuccess: async (data, variables, context) => {
      await queryClient.invalidateQueries({ queryKey: ["savedViews"] });
      await queryClient.refetchQueries({ queryKey: ["savedViews"] });

      options?.onSuccess?.(data, variables, context);
    },
  });

  return { data: data?.createPinnedView, ...rest };
}
